<template>
    <div class="row justify-content-center">
        <div class="col-md-8" style="padding-bottom: 60px">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">PIXSMART</h5>
                    <p class="card-text">
                        Компания ООО «Веб Ру Девелопмент» является производителем наборов для творчества и рисования.
                        Один
                        из уникальных товаров, созданных нашей компании - «Картины на холсте по фотографии своими
                        руками».
                        <br><br>Вы можете обращаться к нам по вопросам оптовых покупок. Также мы изготавливаем наборы с
                        индивидуальным дизайном для корпоративных подарок или товаров под вашим брендом.
                        <br><br>e-mail: <b>an@browseup.ru</b>
                    </p>
                </div>
                <img src="/img/1080_270.jpg" class="card-img-bottom" alt="PIXSMART">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContactsN"
    }
</script>

<style scoped>

</style>